export enum JournalEntryType {
  diary = "diary",
  gratitude = "gratitude",
  fiveMinute = "fiveMinute",
  iAmGreat = "iAmGreat",
}
